import {
  BlockStack,
  Box,
  Button,
  Card,
  InlineStack,
  Text,
} from "@shopify/polaris";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import utils from "../../../../../utils/utils"

const WalletBox = ({setWalletOpen,pageData}) => {
  const router = useHistory();

  return (
    <Box>
      <Card>
        <BlockStack gap={300}>
          <Box>
            <InlineStack gap="200" align="space-between">
              <Box>
                <Text variant="headingSm" as="h6">
                  Payment settings
                </Text>
              </Box>
              <Box>
                <Button variant="primary" onClick={() => setWalletOpen(true)}>Top up</Button>
              </Box>
            </InlineStack>
            <Text as="p" tone="subdued">
            Top up Dropshipman Credits to enable automatic order payment.
            </Text>
          </Box>
          <Card roundedAbove="xs">
            <BlockStack gap={200}>
              <InlineStack gap={100}>
                <span>
                <img height={20} src="/dsm_pay.png" alt="dropshipman" />
                </span>
                <Text variant="headingSm" as="h6">
                  Dropshipman Credits
                </Text>
              </InlineStack>
              <Box>
                <Text variant="heading2xl" as="h3">
                  ${pageData?.wallet_money}
                </Text>
              </Box>
              <Box
                style={{
                  width: "100%",
                  height: "1px",
                  margin: "4px 0",
                  background: "rgba(227, 227, 227, 1)",
                }}
              ></Box>
              <InlineStack>
                <Button variant="tertiary" onClick={()=>{
                  utils.routeJump1(router,`/admin/wallet`)
                }}>Learn more</Button>
              </InlineStack>
            </BlockStack>
          </Card>
        </BlockStack>
      </Card>
    </Box>
  );
};

export default WalletBox;
